import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class PrimengThemeService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  switchTheme(theme: 'light' | 'dark') {
    const themeLink = this.document.getElementById('app-theme') as HTMLLinkElement;
    
    if (themeLink) {
      themeLink.href = theme === 'dark' 
        ? 'assets/themes/primeng-dark-theme.css' 
        : 'assets/themes/primeng-light-theme.css';
    } else {
      const link = this.document.createElement('link');
      link.id = 'app-theme';
      link.rel = 'stylesheet';
      link.href = theme === 'dark' 
        ? 'assets/themes/primeng-dark-theme.css' 
        : 'assets/themes/primeng-light-theme.css';
      this.document.head.appendChild(link);
    }
    
    // Update PrimeNG theme CSS variables
    const root = this.document.documentElement;
    if (theme === 'dark') {
      root.classList.add('p-dark');
    } else {
      root.classList.remove('p-dark');
    }
  }
}